<template>
  <!-- // TODO: [Sportybet] -->
  <div>
    <div class="p-0 transactions">
      <div
        v-for="transaction in transactions"
        :key="transaction.shortId"
        class="m-b-10 transaction"
        :class="{
          expanded: expandedTrans.includes(transaction.shortId),
          'non-selectable-item': submitted && !isTransactionSelected(transaction),
        }"
      >
        <!-- Some case the selections is empty from QA -->
        <div v-if="transaction.selections && transaction.selections[0]" class="p-1 transaction__header">
          <template v-if="!viewOnly">
            <span v-if="isTransactionSelected(transaction)" @click="toggleTransactionSelection(transaction)">
              <FaCheckSquare height="2.1rem" width="2.1rem" class="checked transaction__checkbox" />
            </span>
            <span v-else @click="toggleTransactionSelection(transaction)">
              <FaRegSquare height="2.1rem" width="2.1rem" class="transaction__checkbox unchecked" />
            </span>
          </template>
          <div class="separate" />
          <div class="title">
            <div class="title__description">
              <span>{{ transaction.selections[0] | getTitile }}</span>

              <span v-if="transaction.selections.length > 1"> and {{ transaction.selections.length - 1 }} more </span>
              <span class="font-size-sm"> (Id:{{ transaction.shortId }})</span>
            </div>
            <div class="title__bet-details">
              <span>Total Stake ({{ currency }}) {{ transaction.totalStake }}</span>
              <span>{{ winningStatusMap[transaction.winningStatus] }}</span>
            </div>
          </div>
          <div class="arrow" @click.prevent="expandTrans(transaction.shortId)" />
        </div>
        <div v-if="expandedTrans.includes(transaction.shortId)" class="transaction__details">
          <div class="transaction__details--amount">
            <span>Total Stake ({{ currency }})</span>
            <span>{{ transaction.totalStake }}</span>
          </div>
          <div class="transaction__details--status">
            <span>Total Return ({{ currency }})</span>
            <span class="return" :class="getReturnClass(transaction)">
              {{ getTotalWinnings(transaction) }}
            </span>
          </div>
          <div v-if="!!calculateOdds(transaction)">
            <span>{{ $t('page.issue.bet.odds') }}</span>
            <span class="data">{{ calculateOdds(transaction) }}</span>
          </div>
          <div>
            <span>{{ $t('page.issue.status') }}</span>
            <span class="data">{{ winningStatusMap[transaction.winningStatus] }}</span>
          </div>
          <div>
            <span>{{ $t('page.issue.bet.type') }}</span>
            <span class="data">{{ orderTypeMap[transaction.orderType] }}</span>
          </div>
          <div>
            <span>Time</span>
            <span class="data">{{ transaction.createTime | formatDate }}</span>
          </div>
          <div>
            <span>{{ $t('page.issue.total_matches') }}</span>
            <span class="data">{{ transaction.selections.length }}</span>
          </div>
        </div>
      </div>
    </div>

    <ThemeButton
      v-if="!submitted && !viewOnly"
      block
      :disabled="!selectedTransIssue || !selectedTransIssue.length"
      class="p-1"
      @click="proceed"
    >
      Submit
    </ThemeButton>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { BetHistoryEntity, BetHistoryEntitySelection } from '@/common/api/model';
import { OrderType, TransactionType } from '@/common/config';
import { round } from '@/common/utils';
import FaCheckSquare from '@/components/icons/FaCheckSquare.vue';
import FaRegSquare from '@/components/icons/FaRegSquare.vue';
import MdRadioButtonChecked from '@/components/icons/MdRadioButtonChecked.vue';
import MdRadioButtonUnchecked from '@/components/icons/MdRadioButtonUnchecked.vue';
import ThemeButton from '@/components/ThemeButton.vue';

const userModule = namespace('user');
const chatModule = namespace('chat');
const getTitile = (firstSelection: BetHistoryEntitySelection) => {
  const isOutright = firstSelection.eventId.includes('match');
  return isOutright ? `${firstSelection.home} vs ${firstSelection.away}` : firstSelection.tournamentName;
};

@Component({
  components: {
    FaCheckSquare,
    FaRegSquare,
    MdRadioButtonChecked,
    MdRadioButtonUnchecked,
    ThemeButton,
  },
  filters: {
    formatDate(value: any) {
      const options = {
        hour12: false,
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      } as const;
      const date = new Date(value);
      return date.toLocaleString(undefined, options);
    },
    getTitile(firstSelection: BetHistoryEntitySelection) {
      return getTitile(firstSelection);
    },
  },
})
export default class BetItems extends Vue {
  @Prop({ default: () => [] }) readonly transactions!: BetHistoryEntity[];
  @Prop(Boolean) readonly viewOnly!: boolean;

  @userModule.Getter('currency') currency!: string;
  @chatModule.Mutation('updateExtraTransactionInfo') updateExtraTransactionInfo!: Function;

  winningStatusMap = {
    0: 'Running',
    5: 'Partial Win',
    20: 'Won',
    30: 'Lost',
    40: 'Void',
    90: 'Pending',
  };
  orderTypeMap = OrderType;
  selectedTransIssue: BetHistoryEntity[] = [];
  expandedTrans: string[] = [];
  actionType: string = 'Bet';
  submitted = false;

  isTransactionSelected(transaction: BetHistoryEntity) {
    return this.selectedTransIssue.includes(transaction);
  }

  toggleTransactionSelection(transaction: BetHistoryEntity) {
    if (this.submitted) return;
    if (this.selectedTransIssue.includes(transaction)) {
      this.selectedTransIssue = this.selectedTransIssue.filter((t) => t !== transaction);
    } else {
      this.selectedTransIssue = [...this.selectedTransIssue, transaction];
    }
  }

  getTotalWinnings(trans: BetHistoryEntity) {
    const { winningStatus, totalWinnings } = trans;
    return winningStatus === 0 || winningStatus === 40 ? '--' : totalWinnings;
  }
  getReturnClass(trans: BetHistoryEntity) {
    const { winningStatus } = trans;
    if (winningStatus === 5 || winningStatus === 20) {
      return 'winnings';
    } else if (winningStatus === 30) {
      return 'losses';
    } else {
      return null;
    }
  }
  expandTrans(shortId: string) {
    const index = this.expandedTrans.indexOf(shortId);
    const exist = index !== -1;
    if (exist) {
      this.expandedTrans.splice(index, 1);
    } else {
      this.expandedTrans.push(shortId);
    }
  }
  calculateOdds(trans: BetHistoryEntity) {
    if (trans.orderType === 1 && trans.selections.length === 1) {
      return round(+trans.selections[0].odds, 2);
    } else if (trans.orderType === 2) {
      const val = trans.selections.reduce((acc: number, curr: BetHistoryEntitySelection) => {
        return acc * +curr.odds;
      }, 1);
      return round(val, 2);
    }
    return false;
  }

  proceed() {
    const selectedBetList = this.selectedTransIssue;
    if (!selectedBetList?.length || this.submitted) return;

    const issueMessages = selectedBetList.reduce((acc: string[], cur) => {
      const msg = `${OrderType[cur.orderType] || ''} ${this.actionType} (Id: ${cur.shortId})`;
      return [...acc, msg];
    }, []);
    this.$emit('input', { type: TransactionType.Bet, issueMessages, selected: selectedBetList });
    this.submitted = true;
  }
}
</script>

<style lang="scss">
@import '@/views/Chatroom/RuleEngineHelper/Transaction/index.scss';
.p-0.p-0.p-0 {
  padding: 0;
}

.p-1.p-1.p-1 {
  padding: 1rem;
}
.font-size-sm.font-size-sm {
  font-size: $size-xs;
}
.transaction__details .data.data {
  text-align: right;
}
</style>
